import { useEffect } from "react";
import { studioBranding } from "@/lib/studioBranding";

/**
 * Sets the browser tab title and favicon to reflect the current studio,
 * so a studio's storefront/console shows e.g. "IDLI CHUTNEE" instead of the
 * platform default. Falls back gracefully when no tenant/logo is present.
 */
export function useDocumentBranding(tenant, suffix = "") {
  const name = tenant?.name;
  const logoUrl = tenant?.logo_url;
  const slug = tenant?.slug;

  useEffect(() => {
    if (!name) return;
    document.title = suffix ? `${name} · ${suffix}` : name;

    const brand = studioBranding(slug);
    // Favicons must be square — prefer the bundled square mark; fall back to the
    // studio's uploaded logo only if no square icon is available.
    const iconHref = brand?.iconUrl || logoUrl;
    if (iconHref) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.setAttribute("href", iconHref);
      // apple-touch-icon too
      let apple = document.querySelector("link[rel='apple-touch-icon']");
      if (!apple) {
        apple = document.createElement("link");
        apple.rel = "apple-touch-icon";
        document.head.appendChild(apple);
      }
      apple.setAttribute("href", iconHref);
    }
  }, [name, logoUrl, slug, suffix]);
}
